import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import {
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSingleLineText,
} from '../../../../../graphql/generated/graphql';
import LfToBr from '../../../primitive/LfToBr';
import Linkify from '../../../primitive/Linkify';
import _RouterLink from '../../../primitive/RouterLink';
import Base from './Base';

interface Props {
  field:
    | Pick<DynamicSchemaDefinitionSingleLineText, 'label'>
    | Pick<DynamicSchemaDefinitionMultiLineText, 'label'>
    | Pick<DynamicSchemaDefinitionPositiveInteger, 'label'>
    | Pick<DynamicSchemaDefinitionFixed, 'label'>;
  value: string | number | null;
  className?: string;
}

const AsPlainText = ({ field, value, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <Value>
        <LfToBr text={`${value}`}>
          {(line, key) => (
            <Linkify text={line} key={key}>
              {(url, key) => (
                <RouterLink href={url} withNewTab key={key}>
                  {url}
                </RouterLink>
              )}
            </Linkify>
          )}
        </LfToBr>
      </Value>
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

const RouterLink = styled(_RouterLink)({ display: 'inline' });

export default AsPlainText;
